import { useMemo } from 'react';
import { Workspace } from '@workspace/domain/workspace';
import { SidebarTreeWorkspaceItemContainer } from './SidebarTreeWorkspaceItemContainer';
import type { SidebarTabTarget } from '../SidebarTabContainer';
import { useAtomValue } from 'jotai';
import { controlAtom } from './SidebarTreeStore/sidebarTreeControlState';
import { workspacesAtom, folderTreesAtom } from './SidebarTreeStore/sidebarTreeRecordsState';
import { RootFolderTree } from '@workspace/view-model-folder/domain/FolderTree';

type Props = {
  target: SidebarTabTarget;
};

export const SidebarTree: React.FC<Props> = ({ target }: Props) => {
  const workspaces = useAtomValue(workspacesAtom);
  const folderTrees = useAtomValue(folderTreesAtom);
  const { scrolledWorkspaceId } = useAtomValue(controlAtom);

  const sortedWorkspaces = useMemo(() => {
    const workspaceList = Object.values(workspaces);

    return workspaceList
      .filter((ws) => {
        if (target === 'Shared') return ws.isShared;
        if (target === 'Personal') return ws.isPersonal;
        return false; // unreachable
      })
      .sort(Workspace.compare);
  }, [target, workspaces]);

  if (target === 'Bookmark') return null;

  return (
    <div>
      {sortedWorkspaces.map((workspace) => {
        const rootFolderTree = folderTrees[workspace.id] || RootFolderTree.buildEmpty();
        return (
          <SidebarTreeWorkspaceItemContainer
            key={workspace.id}
            workspace={workspace}
            rootFolderTree={rootFolderTree}
            shouldBeScrolled={scrolledWorkspaceId === workspace.id}
          />
        );
      })}
    </div>
  );
};
